import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { StageCategory } from '@core/stages-types';

@Component({
  selector: 'rt-stage-category-color-indicator',
  templateUrl: './stage-category-color-indicator.component.html',
  styleUrls: ['./stage-category-color-indicator.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'category',
  },
  standalone: true,
})
export class StageCategoryColorIndicatorComponent {
  public category: StageCategory;

  @Input()
  public set stageCategory(category: StageCategory) {
    this.category = category;
  }
  public get stageCategory(): StageCategory {
    return this.category;
  }
}
